import axios from 'axios'
import {NoteUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_notes (context) {
    axios.get(NoteUrls.getAllNotes).then(function (response) {
      context.commit('GET_ALL_NOTES', response.data)
      context.dispatch('loading_false')
    }).catch(function () {
      var data = {data: []}
      context.commit('GET_ALL_NOTES', data)
      context.dispatch('loading_false')
    })
  },
  get_deleted_notes (context) {
    axios.get(NoteUrls.getDeletedNotes).then(function (response) {
      context.commit('GET_DELETED_NOTES', response.data)
      context.dispatch('loading_false')
    }).catch(function () {
      var data = {data: []}
      context.commit('GET_DELETED_NOTES', data)
      context.dispatch('loading_false')
    })
  },
  get_note (context, publicId) {
    axios.get(NoteUrls.getNote + publicId).then(function (response) {
      context.commit('GET_NOTE', response.data)
      context.dispatch('loading_false')
    }).catch(function () {
      var data = {data: []}
      context.commit('GET_NOTE', data)
      context.dispatch('loading_false')
    })
  },
  post_note (context, data) {
    axios.post(NoteUrls.postNote, data).then(function (response) {
      // context.dispatch('get_booking', data.booking_id)
      context.dispatch('get_booking_view_more_detail', data.booking_id)
      context.dispatch('loading_false')
    })
  },
  post_ranger_note (context, data) {
    axios.post(NoteUrls.postRangerNote, data).then(function (response) {
      context.dispatch('get_inspection_booking', data.booking_id)
      context.dispatch('loading_false')
    })
  },
  post_unticketed_alert (context, data) {
    axios.post(NoteUrls.postUnticketed, data).then(function (response) {
      // context.dispatch('get_inspection_booking', data.booking_id)
      context.dispatch('loading_false')
    })
  },
  update_ranger_note (context, data) {
    axios.post(NoteUrls.updateRangerNote, data).then(function (response) {
      context.dispatch('get_alerted_note', data.note_public_id)
      context.dispatch('loading_false')
    })
  },
  
  update_unticketedranger_note(context, data) {
    axios.post(NoteUrls.updateUnticketedRangerNote, data).then(function (response) {
      context.dispatch('get_alerted_note', data.note_public_id)
      context.dispatch('loading_false')
    })
  },


update_raw_alert(context, data) {
    return new Promise((resolve, reject) => {
        axios.put(NoteUrls.updateRawAlert, data).then(function (response) {
            if (response.status === 200) {
                context.dispatch('get_unticketed_alert')
                context.dispatch('loading_false')
                resolve(response.data)
            }
        }).catch(function (error) {
            console.error('Error updating raw alert:', error)
            context.dispatch('loading_false')
            reject(error)
        })
    })
},
  update_note (context, data) {
    axios.patch(NoteUrls.editNote, data).then(function (response) {
      context.dispatch('get_all_notes')
      router.push({
        name: data.redirect_url
      })
      context.dispatch('loading_false')
     })
  },
  delete_note (context, data) {
    axios.patch(NoteUrls.deleteNote, data).then(function (response) {
      alert(response.data.message)
      context.dispatch('loading_false')
    })
  },
  restore_note (context, publicId) {
    axios.get(NoteUrls.restoreNote + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_NOTES', response.data)
      router.push({
        name: 'Module.Notes'
      })
      context.dispatch('loading_false')
    })
  },
  get_alerted_note (context, noteId) {
    axios.get(NoteUrls.getAlertedNote + noteId).then(function (response) {
      context.commit("GET_ALERTED_NOTE", response.data);
    }).catch(function () {
      context.dispatch('loading_false')
    })
    
  },

}
